import Pages from './Pages/Pages';
export default Pages;